import React, { useContext } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  Slide,
  TextField,
  Typography,
  Tooltip
} from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { FormLoader } from '../../../Loader/FormLoader'
import Alert from '@material-ui/lab/Alert'
import CloseIcon from '@material-ui/icons/Close'
import PhoneInput from 'react-phone-input-2'
import AutorenewIcon from '@material-ui/icons/Autorenew'
import ar from 'react-phone-input-2/lang/ar.json'
import { useStyles } from './Styles'
import { LanguageConsumer } from '../../../../LanguageContext'
import { OTPCaptchaContext } from '../../../../OTPCaptcha'
import { ButtonLoader } from '../../../Loader/ButtonLoader'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

function PhoneVerifiedEffect ({ confirmNewPhoneSuccess, onPhoneVerified }) {
  React.useEffect(() => {
    if (confirmNewPhoneSuccess && onPhoneVerified) {
      onPhoneVerified()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmNewPhoneSuccess])
  return null
}

export default function ChangePhone ({ additionalInfoForm, resetPhoneStatus, isCompanyContact, isDelegateContact, countryCodeKey, buttonLabel, onPhoneVerified }) {
  const classes = useStyles()
  const intl = useIntl()
  const { generateCaptcha, captchaData, captchaDataLoading, captchaDataFailure } = useContext(OTPCaptchaContext)

  const [open, setOpen] = React.useState(false)
  const [newPhoneError, setNewPhoneError] = React.useState('')
  const [captchaGuess, setCaptchaGuess] = React.useState('')

  const handleClickOpen = () => {
    reGenerateCaptcha()
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    additionalInfoForm.setFieldValue('newPhone', '20')
    if (!!resetPhoneStatus) {
      resetPhoneStatus()
    }
  }

  const reGenerateCaptcha = () => {
    if (!!generateCaptcha) {
      generateCaptcha()
    }
    setCaptchaGuess('')
  }
  const handleCaptchaGuessChange = (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setCaptchaGuess(event.target.value)
  }

  return (
    <AuthenticatedUserConsumer>
      {({ handleChangePhoneNumber, verifyNewPhoneNumber, verifyNewPhoneSuccess, confirmNewPhoneSuccess, verifyNewPhoneLoading, verifyNewPhoneFailure, verifyNewPhoneFailureMessage }) => (
        <div>
          <PhoneVerifiedEffect confirmNewPhoneSuccess={confirmNewPhoneSuccess} onPhoneVerified={onPhoneVerified}/>
          <button type='button' className={classes.changePhoneButton} onClick={handleClickOpen}>
            {buttonLabel || <FormattedMessage id='ChangePhone.button'/>}
          </button>
          <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            classes={{ paper: classes.ChangePhoneDialogPaper }}
            onClose={handleClose}
            aria-labelledby="ChangePhone-title"
            aria-describedby="ChangePhone-description"
          >
            <DialogTitle id="ChangePhone-title" disableTypography className={classes.ChangePhoneDialogHeader}>
              <Typography variant="h5"><FormattedMessage id='ChangePhone.DialogTitle'/></Typography>
              <IconButton
                edge={false}
                className={classes.ChangePhoneDialogClose}
                color="inherit"
                aria-label="close dialog"
                onClick={handleClose}
              >
                <CloseIcon/>
              </IconButton>
            </DialogTitle>
            <DialogContent className={classes.ChangePhoneDialogContent}>
              <Box p={4}>
                {!!verifyNewPhoneLoading && <FormLoader loading={true}/>}
                {!!verifyNewPhoneFailure && !!verifyNewPhoneFailureMessage &&
                <Alert severity="error">{verifyNewPhoneFailureMessage}</Alert>
                }
                {!!confirmNewPhoneSuccess &&
                <Alert severity="success"><FormattedMessage id='ChangePhone.FormSuccessAlert'/></Alert>
                }
                {!!captchaDataFailure &&
                <Alert severity="error"><FormattedMessage id='captcha.generateErrorAlert'/></Alert>
                }
                {!!verifyNewPhoneSuccess ?
                  <div className={classes.ChangePhoneVerifyWrapper}>
                    <p align={'center'}><strong><FormattedMessage
                      id='AdditionalInfo.VerificationCode.message'/></strong></p>
                    <div className={classes.ChangePhoneVerify}>
                      <InputLabel id="AdditionalInfo.VerificationCode"><FormattedMessage
                        id='Fields.label.VerificationCode'/></InputLabel>
                      <FormControl variant="outlined">
                        <TextField
                          fullWidth
                          placeholder={intl.formatMessage({ id: 'AdditionalInfo.placeholder.VerificationCode' })}
                          id="AdditionalInfo.VerificationCode"
                          type='text'
                          margin="dense"
                          variant="outlined"
                          name='VerificationCode'
                          onChange={additionalInfoForm.handleChange}
                          onBlur={additionalInfoForm.handleBlur}
                          value={additionalInfoForm.values.VerificationCode}
                          helperText={additionalInfoForm.errors.VerificationCode && additionalInfoForm.touched.VerificationCode && additionalInfoForm.errors.VerificationCode}
                          error={additionalInfoForm.errors.VerificationCode && additionalInfoForm.touched.VerificationCode !== undefined}
                        />
                      </FormControl>
                    </div>
                    <Button variant={'contained'} onClick={() => {
                      handleChangePhoneNumber(additionalInfoForm.values.VerificationCode, additionalInfoForm, handleClose, !!isCompanyContact, !!isDelegateContact)
                    }} color="primary">
                      <FormattedMessage id='ChangePhone.DialogActions.verify'/>
                    </Button>
                  </div>
                  :
                  <div className={classes.ChangePhoneVerifyWrapper}>
                    <div className={classes.ChangePhoneVerify}>
                      <InputLabel id="AdditionalInfo.newPhone">
                        <FormattedMessage id='Fields.label.AdditionalInfo.newPhone'/>
                      </InputLabel>
                      <LanguageConsumer>
                        {({ locale }) => (
                          <div className={classes.PhoneInputWrapper}>
                            <PhoneInput
                              value={additionalInfoForm.values.newPhone}
                              enableSearch={true}
                              countryCodeEditable={false}
                              jumpCursorToEnd={true}
                              country={'eg'}
                              localization={locale === 'ar' ? ar : ''}
                              specialLabel={''}
                              excludeCountries={['il']}
                              inputProps={{
                                name: 'newPhone',
                                required: true,
                                autoFocus: true
                              }}
                              searchPlaceholder={intl.formatMessage({ id: 'PhoneInput.Search.placeholder' })}
                              searchNotFound={intl.formatMessage({ id: 'PhoneInput.Search.noResults' })}
                              onChange={(phone, data) => {
                                if (!!countryCodeKey) {
                                  additionalInfoForm.setFieldValue(countryCodeKey, data.countryCode)
                                }
                                additionalInfoForm.setFieldValue('newPhone', phone.toString())
                              }}
                              isValid={(value, country) => {
                                if (country.iso2 === 'eg' && value.length > 2 && value[2] && value[2].toString() !== '1') {
                                  setNewPhoneError(intl.formatMessage({ id: 'validationSchema.phoneStartingError' }))
                                  return false
                                }

                                if (country.countryCode === value.trim() || (country.iso2 === 'eg' && value.length < 12)) {
                                  setNewPhoneError(" ")
                                  return false
                                }

                                if (country.iso2 === 'eg' && value.length > 12) {
                                  setNewPhoneError(intl.formatMessage({ id: 'validationSchema.phoneError' }))
                                  return false
                                } else {
                                  setNewPhoneError('')
                                  return true
                                }
                              }}
                            />
                            {!!newPhoneError && <FormHelperText error={true}>{newPhoneError}</FormHelperText>}
                          </div>
                        )}
                      </LanguageConsumer>
                    </div>
                    <div className={classes.captchaWrapper}>
                      <div className={classes.captchaRow}>
                        <div className={classes.captchaContainer + (!!captchaDataLoading ? ' loading' : '')}>
                          {!!captchaDataLoading && <ButtonLoader loading={true} size={50}/>}
                          {!!captchaData?.img &&
                          <img src={captchaData?.img} alt={'Captcha'}/>}
                        </div>
                        <Tooltip title={intl.formatMessage({ id: 'captcha.regenerate' })}>
                          <IconButton color="primary" aria-label={intl.formatMessage({ id: 'captcha.regenerate' })}
                                      onClick={reGenerateCaptcha} className={classes.captchaGenerateBtn}>
                            <AutorenewIcon/>
                          </IconButton>
                        </Tooltip>
                      </div>
                      <div className={classes.AdditionalInfoRow}>
                        <InputLabel id="AdditionalInfo.CaptchaCode"><FormattedMessage
                          id='Fields.label.CaptchaCode'/></InputLabel>
                        <FormControl variant="outlined">
                          <TextField
                            fullWidth
                            placeholder={intl.formatMessage({ id: 'Fields.Placeholder.CaptchaCode' })}
                            id="AdditionalInfo.CaptchaCode"
                            type='text'
                            margin="dense"
                            variant="outlined"
                            name='CaptchaCode'
                            // inputProps={{ maxLength: 6 }}
                            onChange={handleCaptchaGuessChange}
                            value={captchaGuess}
                          />
                        </FormControl>
                      </div>
                    </div>
                    <Button variant={'contained'}
                            disabled={ ((!!newPhoneError) === true) || ((!!captchaGuess.length) === false) || (captchaGuess.length !== 6) }
                            onClick={() => verifyNewPhoneNumber(additionalInfoForm.values.newPhone, !!isCompanyContact, captchaData?.key, captchaGuess, reGenerateCaptcha, !!isDelegateContact)}
                            color="primary">
                      <FormattedMessage id='ChangePhone.DialogActions.verify'/>
                    </Button>
                  </div>
                }
              </Box>
            </DialogContent>
            <DialogActions className={classes.ChangePhoneDialogFooter}>
              <Button onClick={handleClose} color="primary">
                <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </AuthenticatedUserConsumer>
  )
}
